module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('admin'),
      expression: "'admin'"
    }],
    staticClass: "content-manager"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "card col col-3"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/businesskit.svg")
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("ui.content_manager.first-card.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.content_manager.first-card.subtitle")))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.businessKitLink(),
      "target": "_blank"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("ui.content_manager.first-card.btn")) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "card col col-3"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/forms.svg")
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("ui.content_manager.second-card.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.content_manager.second-card.subtitle")))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.openForms()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.content_manager.second-card.btn")))]), _vm._v(" "), _c('external-form-create')], 1), _vm._v(" "), (!_vm.currentPlanIsTalent) ? _c('div', {
    staticClass: "card col col-3"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/leadsheet.svg")
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("ui.content_manager.third-card.title")))]), _vm._v(" "), _c('p', [_vm._v("  " + _vm._s(_vm.$t("ui.content_manager.third-card.subtitle")))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "https://fanomena.io",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.content_manager.third-card.btn")))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b95b95ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/content_manager/ContentManager.vue
// module id = 1982
// module chunks = 0